module.exports = __webpack_public_path__ + "static/media/free_course_certificate.fc9e5730.png";